import React, { ReactNode } from 'react';
import { ISiteConfig } from '~domain/entities/ISiteConfig';

function WithStyles(props: { children: ReactNode }) {
    const loyaltyConfig = (window?.site as ISiteConfig)?.loyaltyConfig?.loyalty;

    import(`../../styles/${loyaltyConfig?.brandName.toLowerCase()}.css`);

    return <>{props.children}</>;
}

export default WithStyles;